// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".oeos-overlay,.oeos-overlay>div{position:absolute;left:0;right:0;top:0;bottom:0;pointer-events:none}", ""]);
// Exports
module.exports = exports;
